import React from 'react'
import './Services.css'
import dataentry from '../../assets/dataentry.png';
// import emaillisting from '../../assets/emaillist.png';
import leadgen from '../../assets/leadgeneration.png';
import featureImg from '../../assets/Features.jpg';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <section id='services'>
        <div className="container-services">

            <h1>Our Services</h1>

            <div className="services-contents">
                <div className="services-cards">
                <div className="service-card">
                        <img src={leadgen} alt="" loading='lazy'/>

                        <div className="card-content">
                            <h1 className="service-name">Lead Generation Services</h1>

                            <p className="service-des">
                            Unlock the potential of your business with WebHarvester Agency's expert B2B lead generation services. We specialize in providing you with high-quality B2B leads, email lists, LinkedIn leads, and prospect lists customized to your unique requirements. Our dedicated team harnesses the power of top-tier tools, to connect you with the right prospects..<Link to="lead-generation" > Read More</Link>
                            </p>
                        </div>
                        <div className="main-btn">
                            <a href="https://www.fiverr.com/s/RvYKZ8" target='blank'>Order Now</a>
                        </div>
                    </div>

                    <div className="service-card">
                        <img src={dataentry} alt="" loading='lazy' />

                        <div className="card-content">
                            <h1 className="service-name">Administrative Data Entry</h1>

                            <p className="service-des">
                                At WebHarvester Agency, we are expert in  providing meticulous and reliable administrative data entry services tailored to meet your business needs. With our expertise in Microsoft Excel, Word, PowerPoint, and a wide range of administrative tasks, we're here to help you streamline your operations and save valuable time..<Link to="data-entry"> Read More</Link>
                            </p>
                        </div>
                        <div className="main-btn">
                            <a href="https://www.fiverr.com/s/ZqjDX8" target='blank'>Order Now</a>
                        </div>
                    </div>
                    {/* <div className="service-card">
                        <img src={emaillisting} alt="" />

                        <div className="card-content">
                            <h1 className="service-name">Email List Building</h1>

                            <p className="service-des">
                            Our customized email lists help you connect with your target audience and drive engagement, while our expert team ensures your email marketing strategy remains effective.
                            </p>
                        </div>
                    </div> */}

                </div>
            </div>

            <div className="features-benefits">
                <span className="benefits-title">Features & Benefits</span>

                <div className="features-benefits-container">
                    <div className="features">
                        <span className='f-title'>Features</span>
                        <ul class="feature-list">
                            <li>High-Quality Lead Generation Services</li>
                            <li>Targeted Email Lists</li>
                            <li>LinkedIn Lead Generation</li>
                            <li>Administrative Data Entry</li>
                            <li>Prospect List Building</li>
                        </ul>
                    </div>
                    <div className="benefits">
                    <span className='f-title'>Benefits</span>
                        <ul class="feature-list">
                            <li>Reach Your Target Audience Effectively</li>
                            <li>Streamline Your Business Operations</li>
                            <li>Achieve Your Marketing Goals</li>
                            <li>Expand Your Business Network</li>
                            <li>Grow Your Business with Accurate Data</li>
                        </ul>
                    </div>
                    <img src={featureImg} alt="" loading='lazy' />
                </div>
            </div>
        </div>
    </section>
  )
}

export default Services